export enum RenderImageErrorCode {
  UPLOAD_FAILED = 'UPLOAD_FAILED',
  BUCKET_FAILED = 'BUCKET_FAILED',
  DB_INSERT_FAILED = 'DB_INSERT_FAILED',
  DUPLICATE_MATCH = 'DUPLICATE_MATCH',
  DUPLICATE_IMAGE = 'DUPLICATE_IMAGE',
  INVALID_URL = 'INVALID_URL',
  DELETION_FAILED = 'DELETION_FAILED',
  MISSING_FILE = 'MISSING_FILE',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  INVALID_PAYLOAD = 'INVALID_PAYLOAD',
}

export class RenderImageError extends Error {
  constructor(
    public readonly code: RenderImageErrorCode,
    message: string,
    public readonly userMessage: string,
    public readonly cause?: unknown,
  ) {
    super(message);
    this.name = 'RenderImageError';
  }
}

export const isRenderImageError = (err: unknown): err is RenderImageError =>
  err instanceof RenderImageError;
